module.exports = __webpack_public_path__ + "static/img/DeluxeQueenStudio1.623546fb.jpg";